export function get_stored_user() {
  const possible_keys = [
    "user",
    "auth_user",
    "current_user",
    "pending_user_data"
  ];

  for (const key of possible_keys) {
    const raw_user = sessionStorage.getItem(key) || localStorage.getItem(key);

    if (raw_user) {
      try {
        return JSON.parse(raw_user);
      } catch {
        return null;
      }
    }
  }

  return null;
}

export function get_user_role_name(user) {
  return user?.user_role?.role?.name || "";
}

export function is_admin_user(user) {
  const role_name = String(get_user_role_name(user) || sessionStorage.getItem("role") || "").toLowerCase();

  return Boolean(
    user?.is_superuser === true ||
    user?.is_staff === true ||
    role_name === "admin" ||
    role_name === "administrator"
  );
}

export default is_admin_user;
